<div class="version-page-container">
	<div class="version title">
		<span class="message">{{ appVersion }}</span>
	</div>
</div>

<img class="blue-satisfaction-ball" src="assets/images/BolinhaAzul.svg" />
<img class="orange-satisfaction-ball" src="assets/images/BolinhaRosa.svg" />
